import React from "react";
import styled from "styled-components";
import {isMobile} from 'react-device-detect';
import { Link } from "react-router-dom";
import YouTube from 'react-youtube';

import Buttons from "./buttons"
import TicketsButton from "./button-tickets"
import colors from "../settings/colors"

import mam from "../images/mam.png"

const ShowInfo = styled.section`
    display: block;
`
const Content = styled.section`
    margin: 50px 0px;

    p {
        line-height: 1.2em;
    }
    quote {
        display: block;
        background-color: white;
        color: #666;
        padding: 25px;
        border-radius: 5px;
        font-size: 22px;
        text-align: center;
        font-weight: bold;
        margin: 30px auto;
        width: 70%;
    }
    strong {
        color: ${colors.orange};
    }    
`
const Poster = styled.div`
    float: ${isMobile ? "none":"left"};
    width: ${isMobile ? "100%":"35%"};
    margin: 0px 15px 15px 0px;

    img {
        display: block;
        width: 100%; 

        &.poster {
            border-radius: 3px;
        }
    }
`
const Info = styled.div`
    flex-basis: 65%;
    padding-left: ${isMobile ? 0:15}px;
    font-size: 22px;
    line-height: ${isMobile ? 1.2:1.6}em;

    h3 {
        margin-top: ${isMobile ? 15:0}px;
        text-transform: uppercase;
        font-size: 40px;
        font-weight: bold;
        text-align: ${isMobile ? "center":"left"};

        a {
            text-decoration: none;
            color: white;

            &:hover {
                text-decoration: underline;
            }
        }
        small {
            display: block;
            color: #999;
            margin-top: ${isMobile ? 15:0}px;
        }
    }

    strong {
        color: ${colors.orange};
    }

    p small {
        line-height: normal;
    }

    div.specialEvent {
        margin-top: ${isMobile ? 20:0}px;
        text-align: ${isMobile ? "center":"left"};

        span {
            background-color: ${colors.green};
            color: white;
            font-weight: bold;
            padding: 3px 15px;
            display: inline-block;
            margin-bottom: 10px;            
        }
    }
`
const Video = styled.section`
    margin-top: 50px;

  .youtubeContainer {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    overflow: hidden;
    margin-bottom: 50px;
  }
  
  .youtubeContainer iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`

function Show({show}) {
  return (
    <>
        <ShowInfo>
            <Poster>
                <img src={show.poster} alt={show.title + " Poster"} width={200} className="poster" />

                {show.posterInfo && 
                    <div style={{marginTop: "10px"}}>
                        {show.posterInfo}                        
                    </div>
                }
                {show.mastersAtMarshall &&
                    <div style={{marginTop: "10px"}}>
                        <Link to="/speaker-series"><img src={mam} alt="Masters At Marshall" /></Link>

                        <div style={{marginTop: "6px", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                            <small>
                                Packages to the speaker series are available
                            </small>
                            <TicketsButton small show={{
                                tickets: show.mastersAtMarshallTickets
                            }} />
                        </div>
                    </div>
                }  

                {show.photos && 
                    <div className="photos">
                        {show.photos.map((photo,index) => (
                            <img src={photo} alt={"Show Photo"} width={200} className="photo" />
                        ))}
                    </div>
                }              
            </Poster>
            <Info>
                {show.specialEvent && 
                    <div className="specialEvent">
                        <span>
                            Special Event
                        </span>
                    </div>
                }

                <h3>
                    <Link to={show.url}>
                        {show.title}
                    </Link>
                    {show.subtitle && <small>{show.subtitle}</small>}
                </h3>

                <div className="date">{show.dateFormatted}</div>
                {show.timeFormatted && <div className="time">{show.timeFormatted}</div>}
                {show.location && 
                    <div className="location">
                        {show.location}

                        {(show.location == "Joan C. Edwards Performing Arts Center") &&
                            <div style={{
                                marginTop: "-10px",
                                color: "#999",
                            }}>
                                <small>* Parking garage located next to facility (cash only)</small>
                            </div>
                        }
                    </div>
                }

                {show.specialEvent && 
                    <div style={{
                        marginTop: "20px",
                        fontSize: "80%",
                    }}>
                        <span style={{
                            backgroundColor: colors.green,
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "100%",
                            padding: "0px 10px",
                            display: "inline-block",
                            marginRight: "5px",
                        }}>
                            *
                        </span>

                        This show is a <strong>Special Event</strong> and is not part of the Marshall Artists Series.
                    </div>
                }

                {show.description && 
                    <p><small dangerouslySetInnerHTML={{__html: show.description}} /></p>
                }

                <Buttons show={show} tickets /> 
            </Info>
        </ShowInfo>
        {(show.content && show.content.length > 0) && 
            <Content dangerouslySetInnerHTML={{__html: show.content}} />
        }
        {show.website && 
            <h2>
                <a href={show.website} target="_blank" style={{
                    color: colors.orange
                }}>
                    {show.website}
                </a>
            </h2>
        }
        {show.youtubeVideoId && 
            <Video>
                <YouTube
                    videoId={show.youtubeVideoId} 
                    containerClassName="youtubeContainer"
                    opts={{
                        height: '390',
                        width: '640',
                        playerVars: {
                          // https://developers.google.com/youtube/player_parameters
                          autoplay: 0,
                        },
                    }}                  
                />      
            </Video>          
        }
    </>    
  );
}

export default Show;